import { NbAuthOAuth2Token, NbPasswordAuthStrategyOptions } from '@nebular/auth';
import { environment } from '@src/environments/environment';

export let pathJoin = (pathArr: string[]) => {
    return pathArr
        .map(path => {
            if (path[0] === '/') {
                path = path.slice(1);
            }
            if (path[path.length - 1] === '/') {
                path = path.slice(0, path.length - 1);
            }
            return path;
        })
        .join('/');
};

export const BASE_PATH_SERVER = environment.custom_base_path_api;
export const BASE_PATH_IMAGES = environment.custom_base_path_images;
export const BASE_PATH_MOODLE = environment.moodle_path;
export const BASE_PATH_PREMS = environment.prems_path;

export function emailGetToken(module, res, options) {
    return res.body;
}

export const NbEmailPassOAuthProvider_CONFIG: NbPasswordAuthStrategyOptions = {
    name: 'email',

    baseEndpoint: BASE_PATH_SERVER,

    token: {
        class: NbAuthOAuth2Token,
        // key: "access_token"
        getter: emailGetToken,
    },
    login: {
        method: 'POST',
        endpoint: '/oauth2/token',
        // rememberMe: false,
        redirect: {
            success: '/admin/dashboard/',
            failure: null,
        },
        defaultErrors: [
            'Combinazione email/password non corretta, riprovare.',
        ],
        defaultMessages: ['Ti sei autenticato con successo'],
    },

    logout: {
        method: 'get',
        endpoint: '/utenti/logout/',
        redirect: {
            success: '/auth/login/',
            failure: null,
        },
        defaultErrors: ['Something went wrong, please try again.'],
        defaultMessages: ['You have been successfully logged out.'],
    },

    requestPass: {
        endpoint: '/api/auth/request-pass',
        method: 'post',
        redirect: {
            success: '/',
            failure: null,
        },
        defaultErrors: ['Something went wrong, please try again.'],
        defaultMessages: [
            'Reset password instructions have been sent to your email.',
        ],
    },
};

export function samlGetToken(module, res, options) {
    return res;
}

export const NbSamlPassOAuthProvider_CONFIG: NbPasswordAuthStrategyOptions = {
    name: 'saml',

    baseEndpoint: BASE_PATH_SERVER,

    refreshToken: {
        endpoint: '/oauth2/token',
        method: 'POST',
        requireValidToken: false,
        redirect: {
            success: null,
            failure: null,
        },
        defaultErrors: ['Something went wrong, please try again.'],
            defaultMessages: ['Your token has been successfully refreshed.'],
        },

    token: {
        class: NbAuthOAuth2Token,
        // key: "access_token"
        getter: samlGetToken,
    },
    login: {
        method: 'POST',
        endpoint: '/oauth2/token',
        // rememberMe: false,
        redirect: {
            success: '/admin/dashboard/',
            failure: null,
        },
        defaultErrors: [
            'Login/Email combination is not correct, please try again.',
        ],
        defaultMessages: ['You have been successfully logged in.'],
    },

    logout: {
        method: 'get',
        endpoint: '/utenti/logout',

        redirect: {
            success: '/public/dashboard/',
            failure: '/auth/login',
        },
        defaultErrors: ['Something went wrong, please try again.'],
        defaultMessages: ['You have been successfully logged out.'],
    },

    requestPass: {
        endpoint: '/api/auth/request-pass',
        method: 'post',
        redirect: {
            success: '/',
            failure: null,
        },
        defaultErrors: ['Something went wrong, please try again.'],
        defaultMessages: [
            'Reset password instructions have been sent to your email.',
        ],
    },
};
